<template>
	<div class="rfcouponmodel">
			<div class="buttonPanel p-2" v-if="$root.customer_info.mycoupon!=null">
				
				<b-row class="p-0 m-0">
					<b-col lg="8" md="8" sm="12" class="p-0">
					<p class="m-0"> COUPON OFFERS </p>
						<p class="m-0 refBtn"> 
						 Share personalized coupon with your contacts
						 
						</p>
					</b-col >
					<b-col lg="4" md="4" sm="12" class="p-0 text-center">
						
						
						  <p class="mycoupon">{{$root.customer_info.mycoupon}}</p>
						  <p class="m-0 refBtn"> 
						 <button type="button" class=" closeRemRe" v-b-modal="'referacouponfriendpopup'">Share Coupon</button>
						 </p>
						
					</b-col>
				</b-row>
					
				
			</div>
			<!--<b-modal id="setpassword" title="Change Password" ok-only @hidden="resetSelectedForm" >-->
			<b-modal id="referacouponfriendpopup" title="Refer a friend"   ok-only    hide-footer no-close-on-backdrop size="md" centered >
			
				<template #modal-header>
				   
				  <div class="p-0 refHead">Share Coupon</div>
				 
				  <button type="button" aria-label="Close" @click="$bvModal.hide('referacouponfriendpopup')" class="close">×</button>
				</template> <!--@click="$bvModal.hide('bv-modal-example')" -->
				
				<!--<div class="text-right"> <button type="button" aria-label="Close" class=" closeMe" @click="$bvModal.hide('promotionpopup')">×</button></div> -->
				<!--<div class="text-right"> <b-link  class="closeMerf" @click="$bvModal.hide('referacouponfriendpopup'),remindmelater()">×</b-link></div> -->
				<b-row class="offerP22">
					<b-col >
							<!--<p class="mb-2 text-xs text-center">Welcome to Alluraa's Offer Program! Here's how it Works:
							 </p> 
							<ul class="mb-4">
								<li>Use your unique coupon code to share Alluraa with your network</li>
								<li>Extra 20% Off On Minimum Order Of Rs.500</li>
								<li>Have questions? Reach out us at <b-link style="color: #007bff;">info@alluraa.com</b-link></li>
							
							</ul> -->
							
							<b-row class="m-0 mt-3 refCode">
							<b-col lg="8" md="7" sm="7">Your unique coupon code: 
							 <div class="code text-red">{{$root.customer_info.mycoupon}}</div>
							 <input type="hidden" id="testing-code" v-model="referralCode">
							 </b-col>
							<b-col lg="4" md="5" sm="5"> <span class="btn btn-info text-white copy-btn ml-auto btnCopy" @click.stop.prevent="copyTestingCode"> Copy code </span>					</b-col>
							
							</b-row>
							<b-row>
								<b-col class="socialIcondivcoupon">
									Share Now
									
									<b-link>
									<ShareNetwork
									network="email"
									:url="'https://www.alluraa.com/share/'"
									title="Alluraa Coupon"
									:description="linkComments"
									hashtags="Alluraa" >
									<b-img  src="@/assets/sms.svg" class="socialIcondivcoupon--icon"></b-img>
									</ShareNetwork>
									</b-link>												
									<b-link>	
									<ShareNetwork
										network="facebook"
										:url="'https://www.alluraa.com/share/'"
										title="linkComments"
										:description="linkComments"
										:hashtags="referralCode+',Alluraa,Coupon,'+linkComments"
										:quote="linkComments"
										>
										<b-img  src="@/assets/facebook.svg" class="socialIcondivcoupon--icon"></b-img>
									</ShareNetwork>
									<!--<ShareNetwork
									network="facebook"
									url="https://news.vuejs.org/issues/180"
									title="Say hi to Vite! A brand new, extremely fast development setup for Vue."
									description="This week, I’d like to introduce you to 'Vite', which means 'Fast'. It’s a brand new development setup created by Evan You."
									quote="The hot reload is so fast it\'s near instant. - Evan You"
									hashtags="vuejs,vite"
								  >
									Share on Facebook
								</ShareNetwork> -->
									</b-link>
									<b-link>
									<ShareNetwork
										network="whatsapp"
										:url="'https://www.alluraa.com/'"
										title="Alluraa"
										:description="linkComments">
										<b-img  src="@/assets/whatsapp.svg" class="socialIcondivcoupon--icon"></b-img>
									</ShareNetwork>
									</b-link>
												
									<b-link>
									<ShareNetwork
										network="twitter"
										:url="'https://www.alluraa.com'"
										:title="linkComments"
										hashtags="Alluraa,Coupon"
										twitter-user="">
										<b-img  src="@/assets/twitter.svg" class="socialIcondivcoupon--icon"></b-img>
									</ShareNetwork>
									</b-link>
											<b-link>
											<ShareNetwork
												network="telegram"
												url="'https://www.alluraa.com/"
												title="Alluraa."
												:description="linkComments"
												>
												<b-img  src="@/assets/telegram.svg" class="socialIcondivcoupon--icon"></b-img>
											</ShareNetwork>
											</b-link>
												
												
										<!--<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('sms')"><b-img  src="@/assets/sms.svg" class="socialIcondivcoupon--icon"></b-img></b-link>
										
										<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('facebook')"><b-img  src="@/assets/facebook.svg" class="socialIcondivcoupon--icon"></b-img></b-link>
										<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('whatsapp')"><b-img  src="@/assets/whatsapp.svg" class="socialIcondivcoupon--icon"></b-img></b-link>
										<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('twitter')"><b-img  src="@/assets/twitter.svg" class="socialIcondivcoupon--icon"></b-img></b-link>
										<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('telegram')"><b-img  src="@/assets/telegram.svg" class="socialIcondivcoupon--icon"></b-img></b-link> -->
								</b-col>
									

							</b-row>
							
							 <!--<b-row class="mb-4">
							<b-col class="penSIg">
								<b-row class="m-0 mt-3 statusWall text-center">
								<b-col class="dividerR">
									<h2>{{signups}}</h2> 
									<span>SIGNUPS</span>
								</b-col>
								<b-col > 
									<h2>{{$root.currency()}}{{earned}}</h2> 
									<span>EARNED</span>
								</b-col>
								</b-row>
							</b-col>
							</b-row>  -->
							<!--<p class="tandc"> By usign our Referral Program, you agree to our <b-link style="color: #007bff;">Referral Program Term & Conditions</b-link>  </p>-->
							
							
							<!-- <b-button  href="/register/sales-advisor" variant="danger" class="w-100 text-xs w-full  block rounded text-white visited:text-white bg-red-700 font-bold" @click="remindmelater()" >Register Now</b-button> -->
							
							
							
					</b-col>
				</b-row>
				
					
				
				
			  </b-modal>
			

	</div>		
</template>
<script>

/* setpassword

http://localhost:8080/agent/dashboard/setpassword*/

//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";
import '../assets/referacouponpopup.scss';

export default {
  name: 'ShareEmailPopup',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  
  },
  props: { 
	userData: { type: Array},	
  },
  mounted(){
    //this.inLodcard();
	 this.referralCode = this.$root.customer_info.mycoupon;
	 var usernameLo=this.$root.customer_info.username; 
	 if(usernameLo==null || usernameLo=='null'){
	 usernameLo = 'Your Friend';
	 }
	 if(this.$root.customer_info.mycoupon==null || this.$root.customer_info.mycoupon=='null'){
	 this.createCoupon();
	 }
	 
	 
	 this.linkComments = '\n'+usernameLo+' has sent you Coupon Code from Alluraa! \n Get Extra 20% off when you shop on Alluraa.\n Use coupon code '+this.$root.customer_info.mycoupon+' at the Checkout Page.';
	/*var roleIdmy =this.$root.customer_info.role;
	if(roleIdmy>0){
		this.myrole=roleIdmy;
		this.urlLink='/agent/my-shop';
	} */
  },
  computed: {
    
  },
  data() {
    return{
	  referralCode:'',
	  signups:0,
	  earned:0,
	  coform_password: '', 
      new_password: '', 
	  coform_passwordState: null, 
      new_passwordState:null, 
      passwordUrl: this.$root.WEBAPI+'webapi/passwordSet',
      urlprmoCoutUrl: this.$root.WEBAPI+'webapi/promotionCount',
      getreferalUrl: this.$root.WEBAPI+'webapi/getReferralDetails ',
	  createCouponUrl: this.$root.WEBAPI+'walletapi/createCouponAll',
		linkComments:'',
		iamiconfor:'',
		register: {
				new_password:'',
				conformpassword:'',
				rowId:'',
				user_id:'',
            },
			registerState:{
				new_password:null,
				conformpassword:null,
			},
			registerError:{
				new_password:'Please enter password!',
				conformpassword:'Please reenter password!',
			},
			urlLink:'/login',
			myrole:0,
		
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
			var self=this;
			//this.$root.remindmelater = 1;
			//this.$root.customer_info.remindmelater;
			//self.$session.set('remindmelater',1);
			//self.$bvModal.hide('referacouponfriendpopup');
			
				self.axios.post(self.getreferalUrl, {
					  accesskey: self.$root.customer_info.access_key,
					  user_id : self.$root.customer_info.user_id
				  }).then(function (response) {
					  if(response.data.error == 0 || response.data.error == '0'){
						 //console.log(response.result.referer_id);
						
						 self.referralCode = response.data.result.referer_id;
						 self.signups = response.data.result.signups;
						 self.earned = response.data.result.earned;
						// console.log('count'); 
					  }
				  }).catch(function (error) {
					  alert(error);
					 
				  });
			
			
		},
		remindmelater(){
			var self=this;
			//this.$root.remindmelater = 1;
			//this.$root.customer_info.remindmelater;
			self.$session.set('remindmelater',1);
			self.$bvModal.hide('referacouponfriendpopup');
			
				self.axios.post(self.urlprmoCoutUrl, {
					  accesskey: self.$root.customer_info.access_key,
					  user_id : self.$root.customer_info.user_id
				  }).then(function (response) {
					  if(response.data.error == 0 || response.data.error == '0'){
						 
						 console.log('count'); 
					  }
				  }).catch(function (error) {
					  alert(error);
					 
				  });
			
			
		},
		copyTestingCode () {
			var self =this;
			console.log(self.referralCode);
          let testingCodeToCopy = document.querySelector('#testing-code')
			testingCodeToCopy.setAttribute('type', 'text')   
          testingCodeToCopy.select();

          try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
			var messLi= 'Coupon code was copied ' + msg;
			self.$bvToast.toast(messLi, {
					title: 'Unique Coupon code',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'success',
					solid: true,
					appendToast: true
				});
			
          } catch (err) {
            alert('Oops, unable to copy');
          }

          /* unselect the range */
          testingCodeToCopy.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()
        },
		createCoupon() {
			var userId =1;
			var self =this;
			self.axios.post(self.createCouponUrl, {
					accesskey: self.$session.get('access_key'),
					user_id: userId
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
					console.log(response.data.message);
						/*self.$bvToast.toast(response.data.message, {
							title: 'Wallet Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'success',
							solid: true,
							appendToast: true
						 */
						
					}else{
							console.log(response.data.message);
						/*self.$bvToast.toast(response.data.message, {
							title: 'Email Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						}); */
					
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			
			},

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	
	
</style>
